import { render, staticRenderFns } from "./CompanyBranch.vue?vue&type=template&id=682ca0dc&"
import script from "./CompanyBranch.vue?vue&type=script&lang=js&"
export * from "./CompanyBranch.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBranch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports